module.exports = __webpack_public_path__ + "img/AdMonitor.95a2e1e6.svg";